import Redux from "redux";

export default class ReduxHelper {
  private static store: Redux.Store;

  static getState(): Redux.Store {
    return this.store.getState();
  }

  static setStore(store: Redux.Store): void {
    this.store = store;
  }

  static dispatch(f: Redux.Action) {
    return this.store.dispatch(f);
  }
}
